<template>
    <!--Header section-->
    <section class="sales-header">
        <!--Section main container-->
        <div class="logo-login-signup-wrapper">
            <!--Section logo-->
            <div class="logo">
                <router-link :to="{ path: '/sales' }"
                    ><img src="../../assets/images/ring-my-pro-logo.png" alt="Ring My Pro Logo"
                /></router-link>
            </div>
            <!--Section content-->
            <div class="login-signup-wrapper">
                <!--Home-->
                <div class="sales-login">
                    <router-link class="home primary-btn extra-small mobile" :to="{ path: '/sales' }"
                        >Home
                    </router-link>
                </div>
                <!--Log in-->
                <div class="sales-login">
                    <router-link class="login primary-btn extra-small mobile" :to="{ path: '/sales' }"
                        >Log In
                    </router-link>
                </div>
                <!--Sign up-->
                <div class="sales-signup">
                    <router-link class="signup primary-btn extra-small mobile" :to="{ path: '/sign-up' }"
                        >Sign Up</router-link
                    >
                </div>
            </div>
        </div>
        <!--Image that separate sections-->
        <div class="header-separator">
            <img src="../../assets/images/header-separator.png" alt="Separator" />
        </div>
    </section>
</template>
<script>
export default {
    name: "SalesHeader",

    data: function () {
        return {};
    },
    mounted: function () {},
    computed: {},
    methods: {},
};
</script>
